var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('message-modal'),_c('div',[_c('main-header'),_c('deadline-list-filter'),_c('deadline-list-header'),_c('deadline-list-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }